


























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { ShippingAddress } from '@/models/filebunker/shippingaddress';
import { Base } from '@/components/common/base';
import { Utils } from '@/helper/utils';
import { shippingAddressService } from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['isDialog', 'addressDialog', 'methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class ShippingAddressAddPage extends Base {
  public isDialog: boolean;
  public disabledPhone: boolean = true;
  public addressDialog: any;
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public storeId: number;
  public requestProgress: boolean = false;
  public shippingAddress: ShippingAddress = {
    phonePrefix: '1',
  };
  get trigger(): boolean {
    return this.$props.dialog;
  }
  set trigger(val) {
    this.$emit('closedialog', val);
  }
  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.backToList();
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('shippingAddress.alertInvalidForm'));
        this.resetMethodName(methodName);
        return;
      }
      this.submitAddress();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('shippingAddress.btnBack'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('shippingAddress.btnBack'),
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public async mounted(): Promise<void> {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'addressBook');
    
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.storeId = Number(this.$route.params.storeId);
    if (this.$route.params.id) {
      try {
        this.setFields();
        this.formlyShowSkeleton(this.formFields);
        const addresses = await shippingAddressService.getAddress(
          Number(this.$route.params.id),
          this.storeId
        );
        if (addresses) {
          this.shippingAddress = addresses;

          // prefix change
          this.disabledPhone = true;
          if (this.shippingAddress.contact.length >= 10) {
            this.shippingAddress.contact = this.shippingAddress.contact.replace(
              '+',
              ''
            );
            const phone = this.shippingAddress.contact;
            this.shippingAddress.contact = phone.substring(
              phone.length,
              phone.length - 10
            );
            this.shippingAddress.phonePrefix = phone.substring(
              phone.length - 10,
              0
            );
            if (!this.shippingAddress.phonePrefix) {
              this.shippingAddress.phonePrefix = '1';
            }
            this.disabledPhone = this.shippingAddress.phonePrefix === '1';
          } else {
            this.shippingAddress.phonePrefix = '1';
          }
          // tslint:disable-next-line:prefer-for-of
          for (let i = 0; i < this.formFields.length; i++) {
            if (this.formFields[i].key === 'phonePrefix') {
              this.formFields[i].templateOptions.disabled = this.disabledPhone;
            }
          }
        }
      } finally {
        this.formlyHideSkeleton(this.formFields);
      }
    }
    this.setFields();
  }

  public validateAddress(): Vue & { validate: () => boolean } {
    return this.$refs.addressForm as Vue & { validate: () => boolean };
  }

  public async submitAddress(): Promise<void> {
    if(this.validateAddress().validate()){
      var validateRes = this.$validator.errors.items.length > 0;
      if (validateRes) {
        this.showAlert(false, 'Please Enter Valid Details');
        return;
      }

      try {
        this.shippingAddress.contact =
          '+' + this.shippingAddress.phonePrefix + this.shippingAddress.contact;
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (this.$route.params.id) {
          await shippingAddressService.updateAddress(
            Number(this.$route.params.id),
            this.shippingAddress,
            this.storeId
          );
          this.showAlert(
            true,
            this.$t('shippingAddress.alertUpdateShippingAddress')
          );
          this.backToList();
        } else {
          await shippingAddressService.saveAddress(
            this.shippingAddress,
            this.storeId
          );
          this.showAlert(
            true,
            this.$t('shippingAddress.alertSaveShippingAddress')
          );
          this.backToList();
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }

  public setFields(): void {
    this.formFields = [
      // Name
      {
        key: 'name',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 30,
          label: this.$t(
            'shippingAddress.shippingAddressFields.name'
          ) as string,
          required: true,
          disabled: false,
          elementClass:'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 py-0 float-left',
          rules:[
            v => this.required('Name',v)
          ]
        },
      },
      // Company
      {
        key: 'company',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 30,
          label: this.$t(
            'shippingAddress.shippingAddressFields.companyName'
          ) as string,
          required: true,
          disabled: false,
          elementClass:'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 py-0 float-left',
          rules:[
            v => this.required('Company Name',v)
          ]
        },
      },
      // Contact
      {
        key: 'phonePrefix',
        type: 'v-alynk-phone-field',
        required: false,
        templateOptions: {
          counter: 2,
          label: this.$t(
            'shippingAddress.shippingAddressFields.prefix'
          ) as string,
          required: false,
          type: 'number',
          disabled: this.disabledPhone,
          // elementClass: 'flex xs12 sm12 md6 lg6 pr-2',
          // elementStyle: 'float:left;',
          elementClass:'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6  mt-5 py-0 float-left',
          rules:[
            v => this.required('Prefix',v)
          ]
        },
      },
      {
        key: 'contact',
        type: 'v-alynk-text-field',
        required: true,
        // validators: {
        //   contact: (field, model, next) => {
        //     next(Utils.PhoneNoRegex.test(model[field.key]));
        //   },
        // },
        templateOptions: {
          counter: 10,
          label: this.$t(
            'shippingAddress.shippingAddressFields.phone'
          ) as string,
          required: true,
          disabled: false,
          // elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pr-2 float-left',
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 py-0 float-left',
          rules:[
            v => this.required('Phone #',v),
            v => this.PhoneNumber(v)
          ]
        },
      },
      // Street Address 1
      {
        key: 'streetAddress1',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 30,
          label: this.$t(
            'shippingAddress.shippingAddressFields.streetAddress1'
          ) as string,
          required: true,
          disabled: false,
          elementClass:'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Street Address 1',v)
          ]
        },
      },
      // Street Address 2
      {
        key: 'streetAddress2',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 30,
          label: this.$t(
            'shippingAddress.shippingAddressFields.streetAddress2'
          ) as string,
          required: false,
          disabled: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
        },
      },
      // City
      {
        key: 'city',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 30,
          label: this.$t(
            'shippingAddress.shippingAddressFields.city'
          ) as string,
          required: true,
          disabled: false,
          elementClass:'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('City',v),
            v => this.alpha('City',v)
          ]
        },
      },
      // State
      {
        key: 'state',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 2,
          label: this.$t(
            'shippingAddress.shippingAddressFields.state'
          ) as string,
          required: true,
          disabled: false,
          elementClass:'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('State',v),
            v => this.alpha('State',v)
          ]
        },
      },
      // Country
      {
        key: 'country',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 3,
          label: this.$t(
            'shippingAddress.shippingAddressFields.country'
          ) as string,
          required: true,
          disabled: false,
          elementClass:'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Coutry',v),
            v => this.alpha('Coutry',v)
          ]
        },
      },
      // ZipCode
      {
        key: 'zipCode',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 9,
          label: this.$t('shippingAddress.shippingAddressFields.zip') as string,
          required: true,
          disabled: false,
          elementClass:'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Zip', v),
            v => this.zip(v)
          ]
        },
      },
    ];
  }

  public backToList() {
    if (this.isDialog) {
      this.trigger = false;
      this.shippingAddress = {};
    } else {
      this.$router.push({
        name: 'admin.shippingaddresses',
        params: { storeId: this.storeId.toString() },
      });
    }
  }
}
